import { render } from "./ForgottenPasswordConfirm.vue?vue&type=template&id=5b92bf3f&ts=true"
import script from "./ForgottenPasswordConfirm.vue?vue&type=script&lang=ts"
export * from "./ForgottenPasswordConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__